import { render, staticRenderFns } from "./PopupHeaderNotify.vue?vue&type=template&id=14d63f05"
import script from "./PopupHeaderNotify.vue?vue&type=script&lang=js"
export * from "./PopupHeaderNotify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports